import { createContext, useContext, ReactNode } from "react";

interface ModalContextType {
  isInsideModal: boolean;
}

const ModalContext = createContext<ModalContextType>({ isInsideModal: false });

export function ModalContextProvider({ children }: { children: ReactNode }) {
  return <ModalContext.Provider value={{ isInsideModal: true }}>{children}</ModalContext.Provider>;
}

export function useIsInsideModal(): boolean {
  const context = useContext(ModalContext);
  return context.isInsideModal;
}
